import Vue from 'vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

import VueMaterial from 'vue-material';
import VueI18n from 'vue-i18n';
import VueLocalStorage from 'vue-localstorage';
import VueLayers from 'vuelayers';
import Notifications from 'vue-notification';
import Loading from 'vue-loading-overlay';
import vueScrollTo from 'vue-scroll-to';
//import vPage from 'v-page';
import vPage from '../my_modules/v-page/src/index.js';
import VueInstant from 'vue-instant';
import vSelect from 'vue-select';
import WebCam from 'vue-web-cam';
import VueTour from 'vue-tour';
import vueHeadful from 'vue-headful';
import Tooltip from 'vue-directive-tooltip';
//import DisableAutocomplete from 'vue-disable-autocomplete';
//import JsonExcel from 'vue-json-excel';
import LiquorTree from 'liquor-tree';
//import * as VueGoogleMaps from 'vue2-google-maps';

//import 'vue-material/dist/vue-material.min.css'
//import 'vue-material/dist/theme/default.css';
import 'vuelayers/lib/style.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'vue-instant/dist/vue-instant.css';
import 'vue-tour/dist/vue-tour.css';
//import 'vue-directive-tooltip/css/index.css';

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';

import 'jquery-ui/themes/base/all.css';
import 'devextreme/dist/css/dx.common.css';
import '@devexpress/analytics-core/dist/css/dx-analytics.common.css';
import '@devexpress/analytics-core/dist/css/dx-querybuilder.css';

import 'devextreme/dist/css/dx.light.css';
import '@devexpress/analytics-core/dist/css/dx-analytics.light.css';

//import 'vue-awesome-notifications/dist/styles/style.css';
import 'devexpress-dashboard/dist/css/dx-dashboard.light.css';
//import "devexpress-dashboard/dist/css/dx-dashboard.dark.css";
//import "devexpress-dashboard/dist/css/dx-dashboard.carmine.css";
//import "devexpress-dashboard/dist/css/dx-dashboard.darkmoon.css";
//import "devexpress-dashboard/dist/css/dx-dashboard.darkviolet.css";
//import "devexpress-dashboard/dist/css/dx-dashboard.greenmist.css";
//import "devexpress-dashboard/dist/css/dx-dashboard.softblue.css";

import 'vue-material/dist/theme/default.css';
//import 'vue-material/dist/vue-material.min.css';
//import './scss/main.scss'

import axios from 'axios';
//axios.defaults.baseURL = 'localhost:8088';

Vue.use(VueMaterial);
Vue.use(VueI18n);
Vue.use(VueLocalStorage);
Vue.use(VueLayers);
Vue.use(Notifications);
Vue.use(Loading);
Vue.use(vueScrollTo);
Vue.use(vPage, {
  info: true,
  language: 'cn',
  pageSizeMenu: () => [10, 25, 50, 100],
  align: 'center'
});
Vue.use(VueInstant);
Vue.component('v-select', vSelect);
Vue.use(WebCam);
Vue.use(VueTour);
Vue.component('vue-headful', vueHeadful);
Vue.use(require('vue-shortkey'));
Vue.use(Tooltip);
//Vue.use(DisableAutocomplete);
//Vue.component('downloadExcel', JsonExcel);
//Vue.use(VueQrcodeReader);
Vue.use(LiquorTree);
//Vue.use(VueGoogleMaps, {
//  load: {
//    key: 'AIzaSyDrc9okYRYhkWwAeavICKZdDKqcTyZ8TUo',
//    libraries: 'places,drawing,visualization,geometry'
//  },
//});

Vue.config.productionTip = false;

var enJSON = require('./i18n/en.json');
var elJSON = require('./i18n/el.json');
var ruJSON = require('./i18n/ru.json');
var arJSON = require('./i18n/ar.json');

var messages = {
  en: enJSON,
  el: elJSON,
  ru: ruJSON,
  ar: arJSON
};

// method that simplify call to display alert dialog
/**
 * Shows a notification message to the user.
 * @param msg The message text to display.
 * @param type The type of message: 4=error, 3=warn, 2=success, 1=info.
 */
Vue.prototype.$alertMsg = function (msg, type) {
  console.log(`Alert Message: %c${msg}`, 'color: yellow; font-style: italic; background-color: blue;padding: 2px');

  if (msg == null || msg == '') return;

  //trim out only secure origins are allowed
  if (typeof msg == 'string' && msg.toLowerCase().includes('only secure origins')) return;

  //trim out timeout expired
  if (typeof msg == 'string' && msg.toLowerCase().includes('timeout expired')) return;

  this.$root.$emit('display_alert_dialog_window', { message: msg, type: type != null && type != '' ? type : '' });
};

Vue.prototype.$isJsonValid = function (str) {
  if (str == null || str == '') return false;

  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

/**
 * Shows a notification message to the user.
 * @param msg The message text to display.
 * @param type The type of message: 4=error, 3=warn, 2=success, 1=info.
 */
Vue.prototype.$oldAlertMsg = function (msg, type, reset = false) {
  if (msg == null || msg == '') return;

  msg = `<div style="text-align:center!important;">${msg}</div>`;

  if (reset) this.$notify({ group: 'app', clean: true });

  this.$notify({
    group: 'app',
    text: msg,
    type: type == 4 ? 'error' : type == 3 ? 'warn' : type == 2 ? 'success' : type == 1 ? 'info' : ''
  });
};

Vue.prototype.$scrollToElement = function (elem, options) {
  if (!elem) return;

  if (!options) options = { behavior: 'smooth', block: 'start', inline: 'center' };

  let element = document.getElementById(elem);

  if (element) element.scrollIntoView(options);
};

Vue.prototype.$setFocusToElement = function (elem, scroll = false, timeOut = 0) {
  if (!elem) return;

  if (timeOut && timeOut > 0) {
    setTimeout(() => {
      if (this.$refs[elem]) this.$refs[elem].$el.focus({ preventScroll: !scroll });
    }, timeOut);
  } else {
    if (this.$refs[elem]) this.$refs[elem].$el.focus({ preventScroll: !scroll });
  }
};

Vue.prototype.$removeAccents = function (str) {
  if (!str) return '';

  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

const isProduction = process.env.NODE_ENV === 'production';
if (!isProduction) {
  axios.defaults.baseURL = 'http://localhost:5000/';
}

const i18n = new VueI18n({
  locale: localStorage.getItem('fav_language') || 'en',
  fallbackLocale: 'en',
  messages: messages
});

// window.addEventListener('load', (event) => {
//   const sendHeight = () => {
//     window.parent.postMessage(
//       {
//         type: 'RESIZE_IFRAME',
//         height: document.body.scrollHeight
//       },
//       'http://localhost:3000'
//     );
//   };

//   sendHeight();

//   const observer = new MutationObserver(sendHeight);
//   observer.observe(document.body, { childList: true, subtree: true });
// });

new Vue({
  router,
  store,
  render: (h) => {
    const isInIframe = window.self !== window.top;
    const appComponent = isInIframe ? require('./app/app-without-layout.vue').default : require('./app/app.vue').default;

    // if (isInIframe) {
    //   const receiveMessage = (event: MessageEvent) => {
    //     if (event.data.type === 'SET_TOKEN') {
    //       const { token, page, email, lang } = event.data.payload;

    //       store.commit('setJwtToken', token);

    //       localStorage.setItem('token', token);
    //       console.log('main.ts', token);

    //       axios.interceptors.request.use(
    //         (config) => {
    //           config.headers.Authorization = `Bearer ${token}`;
    //           return config;
    //         },
    //         (error) => Promise.reject(error)
    //       );
    //     }
    //   };

    //   window.addEventListener('message', receiveMessage);
    // }

    return h(appComponent);
  },
  i18n
}).$mount('#app');
